export default __webpack_public_path__ + "static/media/mail-templates.afb2c692.svg";